import { render, staticRenderFns } from "./RankKeywordFrequency.vue?vue&type=template&id=b1666104&"
import script from "./RankKeywordFrequency.vue?vue&type=script&lang=js&"
export * from "./RankKeywordFrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports